import { QueryClient } from "@tanstack/react-query";
import { authStore, createApiClient } from "@qorakul/shared/api";

export const API_BASE = import.meta.env["VITE_API_BASE"] ?? "/api";

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, staleTime: 10_000, refetchOnWindowFocus: false } },
});

export const api = createApiClient({
  baseUrl: API_BASE,
  onUnauthenticated: () => {
    authStore.set(null);
    queryClient.clear();
    window.dispatchEvent(new CustomEvent("qorakul:unauthenticated"));
  },
});
